<template>
  <v-row align="start" justify="center" dense>
    <v-col class="content">
      <v-card>
        <v-form ref="form" v-model="form">
          <v-tabs
            color="deep-purple accent-4"
            left>
            <v-tab> Клиенты и материалы </v-tab>
            <v-tab-item>
              <v-container>
                <!--              <v-form ref="form" v-model="form">-->
                <div v-if="reportInfo" class="text-overline mb-4">
                  <span v-if="reportInfo.project">{{ reportInfo.project.name }};</span>
                  {{ reportInfo.date }};
                  <span v-if="reportInfo.place">{{ reportInfo.place.name }};</span>
                  <span v-if="reportInfo.hours">{{ reportInfo.hours }} часа;</span>
                  {{ reportInfo.users }}
                </div>
                <template>
                  <v-row align="center" justify="center">
                    <v-col v-for="(customer, index) in customers"
                           :key="index"
                           :class="index === (customers.length-1) ? '' : 'col-12'"
                           class="flex-md-grow-1 flex-md-shrink-0 py-0 my-0">
                      <customers-combo-box
                        :ref="`combo-${index}`"
                        :rules="[() => !!customers[index] || 'Поле обязательно',
                                 checkCustomerDuplicates]"
                        :value.sync="customers[index]"
                        :education.sync="customerEducation"
                        :is-treatment.sync="customerTreatment"
                        :prev-tests-result.sync="prevTestsResult"
                        :customer-groups.sync="customerGroups"
                        :to-rename.sync="toRename"
                        :multiple="false"
                        :selected-val="customers[index]"
                        @addCustomer="addCustomer()"
                        @clear="onClear(index)" />
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col cols="12" class="py-0">
                      <v-col>
                        <h4>Группы</h4>
                      </v-col>
                      <v-row class="py-0">
                        <v-col v-for="group in customerGroupsList"
                               :key="group.value"
                               cols="12"
                               lg="2"
                               class="py-0">
                          <v-checkbox v-model="customerGroups"
                                      :value="group"
                                      :label="group.name" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col :cols="12" style="padding-top: 0px;padding-bottom: 0px">
                      <v-col>
                        <h4>Образование</h4>
                      </v-col>
                      <v-chip-group
                        v-model="customerEducation"
                        column
                        active-class="primary"
                        mandatory>
                        <v-chip
                          v-for="edu in education"
                          :key="edu.value"
                          :value="edu.value">
                          {{ edu.text }}
                        </v-chip>
                      </v-chip-group>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <template v-if="isOutreach">
                    <v-row align="start" justify="center">
                      <v-col>
                        <h4>Шприцы</h4>
                      </v-col>
                      <v-col class="flex-grow-0 flex-shrink-0">
                        <v-chip>{{ allSyringes }}</v-chip>
                      </v-col>
                    </v-row>
                    <v-row align="start" justify="center">
                      <v-col cols="12" class="report-slider">
                        <v-tabs v-model="activeSyringe">
                          <v-tab
                            v-for="syringe in syringes"
                            :key="syringe.value">
                            {{ syringe.name }} -
                            <span>
                              <b>{{ syringe.amount }}</b>
                            </span>
                          </v-tab>
                        </v-tabs>
                      </v-col>
                    </v-row>
                    <v-row align="start" justify="center">
                      <v-col>
                        <v-tabs-items v-model="activeSyringe" class="overflow-visible">
                          <v-tab-item
                            v-for="syringe in syringes"
                            :key="syringe.value">
                            <v-slider
                              v-model="syringe.amount"
                              :hint="syringe.name"
                              :step="syringe.step"
                              :tick-labels="ticksLabels(syringe.step)"
                              @click:append="addActiveSyringe"
                              @click:prepend="removeActiveSyringe"
                              ticks="always"
                              tick-size="5"
                              max="30"
                              min="0"
                              thumb-label="always"
                              persistent-hint
                              append-icon="mdi-plus"
                              prepend-icon="mdi-minus" />
                          </v-tab-item>
                        </v-tabs-items>
                      </v-col>
                    </v-row>
                  </template>
                  <v-row v-if="isOutreach">
                    <v-col cols="12" class="py-0 my-0">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h4>Материалы</h4>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <template v-for="(prod,idx) in productsPerGroup">
                              <v-row :key="'prodgroup'+idx" class="py-0 my-0">
                                <v-col v-for="product in prod"
                                       :key="product.value"
                                       cols="12"
                                       lg="6"
                                       class="py-0 my-0">
                                  <v-text-field v-model="product.amount"
                                                :label="product.name"
                                                @focus="product.amount = null" />
                                </v-col>
                              </v-row>
                              <div class="divider">
                                <span />
                              </div>
                            </template>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </template>
                <v-row>
                  <v-col cols="12">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <h4>Консультации</h4>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="py-0 my-0">
                          <v-row>
                            <v-col v-for="consult in consultListItems"
                                   :key="consult.value"
                                   cols="12"
                                   class="py-0 my-0"
                                   lg="6">
                              <v-checkbox
                                v-model="consult.amount"
                                :label="consult.name"
                                :false-value="0"
                                :true-value="1"
                                class="py-0 my-0" />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                  <v-col>
                    <v-expansion-panels>
                      <v-expansion-panel v-if="directionListCaseItems.length>0">
                        <v-expansion-panel-header>
                          <h4>Направления</h4>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="py-0 my-0">
                          <v-row>
                            <v-col v-for="direction in directionListCaseItems"
                                   :key="direction.value"
                                   cols="12"
                                   class="py-0 my-0"
                                   lg="6">
                              <v-checkbox
                                v-model="direction.amount"
                                :label="direction.name"
                                :false-value="0"
                                :true-value="1"
                                class="py-0 my-0" />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
              <!--              </v-form>-->
            </v-tab-item>
            <v-tab v-if="isOutreach">
              Тесты и Каскад
            </v-tab>
            <v-tab-item v-if="isOutreach">
              <v-container>
                <v-form ref="formTests">
                  <template>
                    <v-row>
                      <v-col cols="12">
                        <h4>Тесты</h4>

                        <v-row>
                          <v-col :cols="12" style="padding-top: 0px;padding-bottom: 0px">
                            <v-col>
                              Стоите ли вы на учете у нарколога?
                            </v-col>
                            <v-chip-group
                              v-model="customerTreatment"
                              column
                              active-class="primary"
                              mandatory>
                              <v-chip
                                v-for="edu in treatment"
                                :key="edu.value"
                                :value="edu.value">
                                {{ edu.text }}
                              </v-chip>
                            </v-chip-group>
                            <v-divider />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            v-for="test in testsListItems"
                            :key="test.value"
                            cols="12"
                            lg="12">
                            <div class="d-flex">
                              <v-checkbox
                                v-model="test.result.is_tested"
                                @click="test.result.result=!test.result.is_tested ? test.result.result=null: test.result.result"
                                :key="`check-${test.name}`"
                                label="Протестирован" />
                            </div>
                            <v-col :cols="12" style="padding-top: 0px;padding-bottom: 0px">
                              <!--                              <v-card-text>-->
                              <h4>
                                <span v-if="test.diseasetype" class="subheading">{{ test.diseasetype.name }}</span>
                              </h4>
                              <v-chip-group
                                :key="`group-${test.name}`"
                                v-model="test.result.result"
                                column
                                active-class="primary">
                                <v-chip
                                  v-for="res in results"
                                  :key="`check-${test.name}-${res.text}`"
                                  :disabled="!test.result.is_tested"
                                  :value="res.value"
                                  @click="test.result.is_positive=test.result.result">
                                  {{ res.text }}
                                </v-chip>
                              </v-chip-group>
                              <!--                              </v-card-text>-->
                              <!--                              <v-card-text>-->
                              <span class="subheading">Результат предыдущего теста</span>
                              <v-chip-group
                                v-model="test.result.result_prev"
                                column
                                active-class="primary">
                                <v-chip
                                  v-for="res in results_prev"
                                  :key="res.text"
                                  :disabled="!test.result.is_tested"
                                  :value="res.value">
                                  {{ res.text }}
                                </v-chip>
                              </v-chip-group>
                              <v-divider />
                            </v-col>
                          </v-col>
                        </v-row>
                        <v-row />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-simple-table>
                          <template v-slot:default>
                            <tbody>
                              <tr
                                v-for="item in nonZeroProducts"
                                :key="item.name">
                                <td>{{ item.text }}</td>
                                <td>{{ item.amount === true ? 1 : item.amount }}</td>
                                <td>{{ item.result ? (item.result.result === 1 ? "Положительный" : "Отрицательный") : '' }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </template>
                  <!--                  <template>-->
                  <!--                    <v-row class="py-0 my-0">-->
                  <!--                      <v-col cols="12"-->
                  <!--                             lg="6"-->
                  <!--                             class="py-0 my-0">-->
                  <!--                        <BaseDatePicker ref="indate_acd"-->
                  <!--                                        :rules="[() => !!vldate_acd || 'Поле обязательно']"-->
                  <!--                                        :value="indate_acd"-->
                  <!--                                        @dateUpdated="setInDate"-->
                  <!--                                        picker-type="date"-->
                  <!--                                        label="Дата начала отчетного периода" />-->
                  <!--                      </v-col>-->
                  <!--                      <v-col cols="12"-->
                  <!--                             lg="6"-->
                  <!--                             class="py-0 my-0">-->
                  <!--                        <BaseDatePicker ref="vldate_acd"-->
                  <!--                                        :rules="[() => !!vldate_acd || 'Поле обязательно']"-->
                  <!--                                        :value="vldate_acd"-->
                  <!--                                        @dateUpdated="setVlDate"-->
                  <!--                                        picker-type="date"-->
                  <!--                                        label="Последняя дата сдачи-->
                  <!--анализов на вирусную-->
                  <!--нагрузку в данном отчетном-->
                  <!--периоде" />-->
                  <!--                      </v-col>-->
                  <!--                      <v-col cols="12"-->
                  <!--                             lg="6"-->
                  <!--                             class="py-0 my-0">-->
                  <!--                        <v-text-field v-model="num_vl_acd"-->
                  <!--                                      @focus="num_vl_acd = null"-->
                  <!--                                      label="Вирусная нагрузка" />-->
                  <!--                      </v-col>-->
                  <!--                      <v-col cols="12"-->
                  <!--                             lg="6"-->
                  <!--                             class="py-0 my-0">-->
                  <!--                        <v-text-field v-model="num_vl_acd"-->
                  <!--                                      @focus="num_vl_acd = null"-->
                  <!--                                      label="Вирусная нагрузка" />-->
                  <!--                      </v-col>-->
                  <!--                    </v-row>-->
                  <!--                  </template>-->
                </v-form>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-form>
        <v-card-actions>
          <v-col cols="8">
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-spacer />
          </v-col>
          <v-col cols="4">
            <v-btn
              @click="deleteCustomer()"
              color="grey"
              plain>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn
              @click="submit()"
              :disabled="!form"
              color="primary">
              Сохранить
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import {mapState} from 'vuex'

import ReportsMixin from './ReportsMixin'
import CustomersComboBox from '../../base/CustomersComboBox'
// import BaseDatePicker from '../../base/BaseDatePicker'


export default {
  name: "ReportIndicatorsForm",
  components: {CustomersComboBox},
  mixins: [ReportsMixin],
  data () {
    return {
      form: false,
      indate_acd:null,
      vldate_acd:null,
      num_vl_acd:null,
      customers: [''],
      tab: null,
      activeSyringe: 0,
      selectedItem: '',
      items: [],
      notSyringes: [],
      syringes: [],
      consultancies: [],
      directions: [],
      customerGroups: [],
      toRename: [],
      customerOld: [],
      tests: [],
      errorMessages: '',
      results: [{text: 'Отрицательный', value: 0}, {text: 'Положительный', value: 1}],
      results_prev: [{text: 'Неизвестно', value: 998},
        {text: 'Отрицательный', value: 0}, {
        text: 'Положительный',
        value: 1
      }, {text: 'Отказ от ответа', value: 997}],
      education: [{text: 'Неизвестно', value: 0}, {text: 'Неполное среднее', value: 1}, {
        text: 'Среднее',
        value: 2
      }, {text: 'Среднее специальное', value: 3},
        {text: 'Неполное высшее', value: 4}, {text: 'Высшее', value: 5}],
      treatment: [{text: 'Не знаю', value: 998}, {text: 'Да', value: 1}, {text: 'Нет', value: 0}],
      customerEducation: 0,
      customerTreatment: 998
    }
  },
  computed: {
    ...mapState({
      customersInReport: state => state.newOutreachReports.customers,
      productsList: state => state.tableData.products,
      customerGroupsList: state => state.tableData.customerGroups,
      testsList: state => state.tableData.tests,
      directionsList: state => state.tableData.directions,
      consultingsList: state => state.tableData.consultings
    }),
    productsGroups () {
      return this.notSyringes.map(item => item.field_group)
          .filter((value, index, self) => self.indexOf(value) === index)
    },
    productsPerGroup () {
      let data = {}
      this.productsGroups.forEach(g => data[g] = this.notSyringes.filter(v => v.field_group === g))
      return data
    },
    allSyringes () {
      return this.syringes.reduce((accumulator, syringeType) => {
        return accumulator + parseInt(syringeType.amount)
      }, 0)
    },
    nonZeroProducts () {
      let nonZeroProducts = [],
          nonZeroSyringes = this.syringes.filter(product => product.amount > 0),
          nonZeroNotSyringes = this.notSyringes.filter(product => product.amount > 0),
          nonTests = this.testsListItems.filter(product => product.result.result !== null),
          nonConsults = this.consultListItems.filter(product => product.amount > 0)
      nonZeroProducts = nonZeroProducts.concat(nonZeroSyringes, nonZeroNotSyringes, nonConsults, nonTests)
      return nonZeroProducts
    }
  },
  created () {
    let customer = ''
    if (this.$route.params.customerId !== 'new') {
      this.customers[0] = this.$route.params.customerId
    }
    customer = this.$store.state.newOutreachReports.customers.find(customer => customer.code === this.customers[0])
    let notSyringes = this.prepareService(this.productsListItems.filter(product => {
      return product.name.indexOf('шприц') === -1
    }), customer)

    let productsSyr = [
      ...this.productsListItems.filter(product => {
        return product.name.indexOf('шприц') !== -1
      })]

    let syringesStep = productsSyr.map(product => {
      if (product.value === 1) {
        product.step = 10
      } else {
        product.step = 5
      }
      product.name = product.name.replace('(', '').replace(') ', '').replace('шприц ', '').slice(0, 5)
      return product
    })

    let syringes = this.prepareService(syringesStep, customer)
    let consultancies = this.prepareService(this.consultListItems, customer, 'consult')
    let directions = this.prepareService(this.directionListCaseItems, customer, 'direct')

    let tests = this.testsListItems.map(product => {
      let params = this.findTestParams(customer, product.id)
      product.disease_id = product.diseasetype.id
      // product.diseasetype=product.result.diseasetype
      product.tests_id = product.result.tests_id
      if (customer) {
        product.id = params.id
        product.customers_id = params.customers_id
        product.redcap_repeat_instance = params.redcap_repeat_instance
        product.result = params.result
        product.tests_id = params.tests_id
      }
      return product
    })

    if (customer) {
      let customerGroups = this.customerGroupsListItems.map(group => {
        return customer.customerGroups.find(gr => group.id === gr.id)
      })
      this.$set(this, 'customerEducation', customer.education)
      this.$set(this, 'customerTreatment', customer.is_treatment)

      this.$set(this, 'customerGroups', customerGroups.filter(x => !!x))
    }
    this.$set(this, 'notSyringes', notSyringes)
    this.$set(this, 'syringes', syringes)
    this.$set(this, 'consultancies', consultancies)
    this.$set(this, 'tests', tests)
    this.$set(this, 'directions', directions)
  },
  methods: {
    prepareService (listItems, customer, type) {
      return listItems.map(service => {
        service.amount = this.findServiceVolume(customer, service, type)
        let params = this.findServiceParams(customer, service, type)
        service.id = params.id
        service.products_id = params.products_id
        service.consultations_id = params.consultations_id
        service.directions_id = params.directions_id
        service.customers_id = params.customers_id
        service.redcap_repeat_instance = params.redcap_repeat_instance
        return service
      })
    },
    addActiveSyringe () {
      if (this.syringes[this.activeSyringe].amount < (24 + this.syringes[this.activeSyringe].step))
        this.syringes[this.activeSyringe].amount += this.syringes[this.activeSyringe].step
    },
    removeActiveSyringe () {
      if (this.syringes[this.activeSyringe].amount >= 0 + this.syringes[this.activeSyringe].step)
        this.syringes[this.activeSyringe].amount -= this.syringes[this.activeSyringe].step
    },
    addCustomer () {
      this.customers.push('')
      this.$nextTick(() => {
        this.$refs['combo-' + (this.customers.length - 1)][0].$children[0].focus()
      })
    },
    setInDate () {

    },
    setVlDate () {

    },
    onClear (idx) {
      if (this.customers.length > 1) {
        let nexCustomers = this.customers.filter((customer, index) => index !== idx)
        this.customers = []
        this.$nextTick(() => {
          this.customers = nexCustomers
        })
      }
    },
    getButtonColor (id) {
      let activeProduct = this.notSyringes.find(product => product.value === id)
      return activeProduct.amount > 0 ? 'primary' : ''
    },
    deleteCustomer () {
      // let route = this.reportType === 'outreach' ? 'ReportOutreachList' : 'ReportCaseList'
      let vm = this
      let route = this.reportTypeRoute + 'List'
      this.$store.commit("newOutreachReports/deleteCustomer", vm.$route.params.customerId)
      this.$router.push({name: route, params: {reportId: this.reportId}})
    },
    submit () {
      if (this.validate()) {
        const services = [].concat(this.syringes, this.notSyringes)
        let route = this.reportTypeRoute + 'List'
        let vm = this
        let tests = this.tests.filter(v => v.result.is_tested)
        this.$store.dispatch("newOutreachReports/addCustomers", {
          customers: this.customers,
          tests: tests,
          products: services,
          consultings: this.consultancies.filter(v => 'amount' in v ? (v.amount || v.amount > 0) : true),
          directions: this.directions.filter(v => 'amount' in v ? (v.amount || v.amount > 0) : true),
          customerGroups: this.customerGroups,
          customerEducation: this.customerEducation,
          customerTreatment: this.customerTreatment,
          reportType: this.reportType
        })
        vm.$store.dispatch("newOutreachReports/saveReport", {
          reportId: vm.$store.state.newOutreachReports.id,
          type: vm.reportType,
          toRename: vm.toRename,
          codes: this.customers
        })
        vm.$router.push({name: route, params: {reportId: vm.reportId, lastEdited: this.customers[0]}})
      } else {
        this.$vuetify.goTo('.error--text', {offset: 100})
      }
    },

    validate () {
      return this.$refs.form.validate()
    },
    findServiceVolume (customer, serviceData, type) {
      if (!customer) return 0
      let services = [...customer.products]
      let cond = 'products_id'
      if (type === 'direct') {
        services = [...customer.directions]
        cond = 'directions_id'
      } else if (type === 'consult') {
        services = [...customer.consultings]
        cond = 'consultations_id'
      }
      // let services = [...customer.consultings, ...customer.products, ...customer.tests]
      let serviceId = serviceData['value']

      const service = services.find(clientsService => clientsService[cond] === serviceId)

      return service ? type ? 1 : service.amount : 0
    },

    findServiceParams (customer, serviceData, type) {
      if (!customer) return 0
      let services = [...customer.products]
      let cond = 'products_id'
      if (type === 'direct') {
        services = [...customer.directions]
        cond = 'directions_id'
      } else if (type === 'consult') {
        services = [...customer.consultings]
        cond = 'consultations_id'
      }
      let serviceId = serviceData['value']
      const service = services.find(clientsService => clientsService[cond] === serviceId)
      if (!service) {
        return {
          'id': null,
          'products_id': serviceId,
          'customers_id': null,
          'redcap_repeat_instance': null,
          'consultations_id': null,
          'directions_id': null
        }
      }

      return {
        'id': service.id,
        'products_id': service.products_id,
        'customers_id': service.customers_id,
        'redcap_repeat_instance': service.redcap_repeat_instance,
        'consultations_id': service.consultations_id,
        'directions_id': service.directions_id
      }
    },
    findTestParams (customer, serviceId) {
      if (!customer) return 0
      let services = [...customer.tests]
      const service = services.find(clientsService => clientsService.tests_id === serviceId)
      if (!service) {
        return {
          'id': null, 'tests_id': serviceId, 'customers_id': customer.id, 'redcap_repeat_instance': null,
          'result': {
            'is_tested': false,
            'is_positive': false,
            'link_id': null,
            'id': null,
            'result': null,
            'result_prev': null
          }, 'diseasetype': {'name': null, 'id': null}
        }
      }

      return {
        'id': service.id, 'tests_id': service.tests_id, 'customers_id': service.customers_id,
        'redcap_repeat_instance': service.redcap_repeat_instance,
        'result': service.result, 'diseasetype': service.diseasetype
      }
    },
    ticksLabels (step) {
      let res = []
      for (let i = 0; i <= 30; i++) {
        if (i % step === 0) {
          res.push(i)
        }
      }
      return res
    },
    checkCustomerDuplicates (customer) {
      return this.$route.params.customerId === customer || !this.customersInReport.some(reportCustomer => {
        return reportCustomer.code === customer
      }) || 'Клиент повторяется'
    }
  }
}
</script>
<style lang="scss">
.report-slider .v-slide-group__prev, .report-slider .v-slide-group__next {
  display: none !important;
}

.shr-button {
  max-width: 100%;

  span {
    max-width: 100%;
    text-align: left;
    display: inline;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.content {
  max-width: 800px;
}

.overflow-visible {
  overflow: visible !important;
}

.red-text {
  background-color: red !important;
  border-color: red !important;
}
.divider {
		border-bottom: 1px solid #FFF;
		background-color: #DADADA;
		//height: 1px;
		margin: 0.5em 0px 1.5em;
}

.divider span {
		display: block;
		width: auto;
		//height: 1px;
		background-color: #DADADA;
}

</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportIndicatorsForm.vue